<template>
  <div id="sales-reports-view" class="sales-reports-container">
  <div class="flex flex-col">

    <!-- BREADCRUMB -->
    <breadcrumb-base :breadcrumb="breadcrumb" title="RechargeSummaryReport">
    </breadcrumb-base>

    <!--    Empty List State -->
    <transition name="fade" v-if="walletHistory.length === 0">
      <div class="h-screen flex w-full bg-img" >
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
<!--          <img src="@/assets/images/pages/svg_blank.svg" :alt="$t('NoData')"-->
<!--               class="mx-auto mb-4 max-w-full">-->
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl">{{$t('NoData')}}</h1>
        </div>
      </div>
    </transition>


    <div>

      <table class="header-table" style="width: auto;" v-if="walletHistoryRaw">
        <thead>
        <th class="text-center">
          {{ $t('TotalAmount') }}
        </th>
        </thead>
        <tbody>
        <tr>
          <td class="text-center">
            <span>{{ walletHistoryRaw.total_value | germanNumberFormat4 }}</span>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="w-full px-3" v-show="walletHistory.length > 0">
        <thead class="justify-between">
        <tr class="">
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('Date') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('TransactionMode') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('Amount') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('OldCredit') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('NewCredit') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('OldBalance') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('NewBalance') }}</span>
          </th>
          <th class="px-16 py-2">
            <span class="text-gray-700">{{ $t('Remarks') }}</span>
          </th>
        </tr>
        </thead>
        <tbody class="">
        <tr class="bg-white shadow-lg my-5 rounded" :key="indextr" v-for="(tr, indextr) in walletHistory">
          <td>
            <p class="font-medium" style="max-width: 100px; word-break: normal !important;">{{ tr.updated | dateFormat }}</p>
          </td>
          <td>
            <p class="font-medium truncate">{{ tr.transaction_mode | title | uppercase }}</p>
          </td>
          <td>
            <p class="font-medium truncate table-value-item" >{{ tr.value | germanNumberFormat }}</p>
          </td>
          <td>
            <p class="font-medium truncate" >{{ tr.to_standing_credit | germanNumberFormat }}</p>
          </td>
          <td>
            <p class="font-medium truncate" >{{ tr.to_credit | germanNumberFormat }}</p>
          </td>
          <td>
            <p class="font-medium truncate" v-if="activeUserInfo.balance_type == 0">{{ (tr.to_standing_balance) | germanNumberFormat }}</p>
            <p class="font-medium truncate"  v-if="activeUserInfo.balance_type == 1">{{ (tr.to_standing_balance - tr.to_standing_credit) | germanNumberFormat }}</p>
          </td>
          <td>
            <p class="font-medium truncate" v-if="activeUserInfo.balance_type == 0">{{ (tr.to_balance) | germanNumberFormat }}</p>
            <p class="font-medium truncate" v-if="activeUserInfo.balance_type == 1">{{ (tr.to_balance - tr.to_credit) | germanNumberFormat }}</p>
          </td>
          <td>
            <p class="font-medium" style="max-width: 200px;">{{ tr.remarks }}</p>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import VxModal from '@/layouts/components/custom/VxModal'

export default {
  name: 'RechargeSummaryReport',
  components: {
    Datepicker,
    VxModal,
  },
  data() {
    return {
      cPage: 1,
      errorFetching: false,
      breadcrumb: [
        { title: 'Home', i18n: 'Home', url: '/' },
        { title: 'Recharge Summary Report', i18n: 'RechargeSummaryReport', active: true },
      ],
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    walletHistory() {
      return this.$store.state.customer.walletHistory
    },
    walletHistoryRaw() {
      return this.$store.state.customer.walletHistoryRaw
    },
    vPage() {
      return this.$store.state.customer.vPage
    },
    vTotalPages() {
      return this.$store.state.customer.vTotalPages
    },
  },
  methods: {
    getTransactionType(value) {
      if (value === 0) return 'Credit'
      if (value === 1) return 'Cash'
      return ''
    },
    listPageChanged(item) {
      this.fetchWalletHistory(this.cPage - 1)
    },
    fetchWalletHistory(page = '0') {
      this.$vs.loading()
      this.$store.dispatch('customer/fetchCustomerWalletHistory', { page })
        .then((data) => {
          this.$vs.loading.close()
          this.errorFetching = false
        })
        .catch((error) => {
          console.error(error)
          this.$vs.loading.close()
          this.errorFetching = true
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: error.response.data.message || error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
  },
  created() {
    this.fetchWalletHistory()
  },
}
</script>

<style lang="scss">
.header-table {
  width: auto;

  th {
    font-weight: normal;
    font-size: 14px;
    min-width: 200px;
  }

  td {
    font-weight: bold;
    font-size: 24px;
    color: rgba(var(--vs-primary), 1);
  }
}
.sales-reports-container {
  table {
    border-collapse:separate;
    border-spacing:0 15px;
    tr {
      th {
        text-align: center;
        padding: 10px 8px;
      }
      td {
        text-align: center;
        padding: 14px 12px;
      }
    }
  }
}
</style>
